export const GET_INTERACTIONS_REQUEST = 'GET_INTERACTIONS_REQUEST';
export const GET_INTERACTIONS_FAILURE = 'GET_INTERACTIONS_FAILURE';
export const GET_INTERACTIONS_SUCCESS = 'GET_INTERACTIONS_SUCCESS';
export const SEARCH_INTERACTIONS_SUCCESS = 'SEARCH_INTERACTIONS_SUCCESS';
export const CLEAR_PANEL_INTERACTIONS = 'CLEAR_PANEL_INTERACTIONS';
export const CLEAR_PANEL_HAS_MORE_INDICATOR = 'CLEAR_PANEL_HAS_MORE_INDICATOR';

export const NEW_INTERACTION_RECEIVED = 'NEW_INTERACTION_RECEIVED';
export const NEW_ONAIR_INTERACTION_RECEIVED = 'NEW_ONAIR_INTERACTION_RECEIVED';

export const GET_SINGLE_INTERACTION_REQUEST = 'GET_SINGLE_INTERACTION_REQUEST';
export const GET_SINGLE_INTERACTION_FAILURE = 'GET_SINGLE_INTERACTION_FAILURE';
export const GET_SINGLE_INTERACTION_SUCCESS = 'GET_SINGLE_INTERACTION_SUCCESS';

export const GET_INTERACTION_THREAD_REQUEST = 'GET_INTERACTION_THREAD_REQUEST';
export const GET_INTERACTION_THREAD_FAILURE = 'GET_INTERACTION_THREAD_FAILURE';
export const GET_INTERACTION_THREAD_SUCCESS = 'GET_INTERACTION_THREAD_SUCCESS';

export const CLEAR_THREADS = 'CLEAR_THREADS';
export const APPEND_THREAD_REPLY = 'APPEND_THREAD_REPLY';
export const SET_THREAD_ID = 'SET_THREAD_ID';
export const SET_THREAD_CHANNEL_TYPE = 'SET_THREAD_CHANNEL_TYPE';
export const SET_THREAD_DIALOG_VISIBLE = 'SET_THREAD_DIALOG_VISIBLE';

export const SET_MEDIA_IS_PLAYING = 'SET_MEDIA_IS_PLAYING';

export const SET_INITIAL_PANEL_PAGE = 'SET_PANEL_PAGE';
export const INCREMENT_PANEL_PAGE = 'INCREMENT_PANEL_PAGE';
export const DECREMENT_PANEL_PAGE = 'DECREMENT_PANEL_PAGE';

export const ADD_MANUAL_PANEL = 'ADD_MANUAL_PANEL';
export const REMOVE_MANUAL_PANEL = 'REMOVE_MANUAL_PANEL';

export const GET_PANELS_REQUEST = 'GET_PANELS_REQUEST';
export const GET_PANELS_FAILURE = 'GET_PANELS_FAILURE';
export const GET_PANELS_SUCCESS = 'GET_PANELS_SUCCESS';

export const CREATE_PANEL_REQUEST = 'CREATE_PANEL_REQUEST';
export const CREATE_PANEL_FAILURE = 'CREATE_PANEL_FAILURE';
export const CREATE_PANEL_SUCCESS = 'CREATE_PANEL_SUCCESS';

export const UPDATE_PANEL_SETTINGS = 'UPDATE_PANEL_SETTINGS';
export const UPDATE_PANEL_SETTINGS_FAILURE = 'UPDATE_PANEL_SETTINGS_FAILURE';
export const UPDATE_PANEL_SETTINGS_SUCCESS = 'UPDATE_PANEL_SETTINGS_SUCCESS';

export const DELETE_PANEL_REQUEST = 'DELETE_PANEL_REQUEST';
export const DELETE_PANEL_FAILURE = 'DELETE_PANEL_FAILURE';
export const DELETE_PANEL_SUCCESS = 'DELETE_PANEL_SUCCESS';
export const UPDATE_PANEL_ORDER = 'UPDATE_PANEL_ORDER';

export const PAUSE_PANEL = 'PAUSE_PANEL';
export const UNPAUSE_PANEL = 'UNPAUSE_PANEL';
export const CLEAR_PANEL_PAUSED = 'CLEAR_PANEL_PAUSED';
export const CLEAR_DASHBOARD_PANEL_PAUSED = 'CLEAR_DASHBOARD_PANEL_PAUSED';

export const SET_GALLERY_IMAGES = 'SET_GALLERY_IMAGES';
export const SET_GALLERY_VISIBLE = 'SET_GALLERY_VISIBLE';
export const SET_GALLERY_INDEX = 'SET_GALLERY_INDEX';

export const SET_PANEL_SETTINGS_DIALOG = 'SET_PANEL_SETTINGS_DIALOG';
export const SET_PANEL_SETTINGS_DIALOG_VISIBLE = 'SET_PANEL_SETTINGS_DIALOG_VISIBLE';

export const DELETE_INTERACTION_SUCCESS = 'DELETE_INTERACTION_SUCCESS';
export const DELETE_INTERACTION_FAILURE = 'DELETE_INTERACTION_FAILURE';

export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';

export const GET_SEARCH_RESULTS_SUCCESS = 'GET_SEARCH_RESULTS_SUCCESS';
export const GET_SEARCH_RESULTS_REQUEST = 'GET_SEARCH_RESULTS_REQUEST';
export const GET_SEARCH_FIELDS_REQUEST = 'GET_SEARCH_FIELDS_REQUEST';
export const GET_SEARCH_FIELDS_SUCCESS = 'GET_SEARCH_FIELDS_SUCCESS';
export const GET_SEARCH_FIELDS_FAILURE = 'GET_SEARCH_FIELDS_FAILURE';

export const GET_ONAIR_INTERACTIONS_REQUEST = 'GET_ONAIR_INTERACTIONS_REQUEST';
export const GET_ONAIR_INTERACTIONS_FAILURE = 'GET_ONAIR_INTERACTIONS_FAILURE';
export const GET_ONAIR_INTERACTIONS_SUCCESS = 'GET_ONAIR_INTERACTIONS_SUCCESS';

export const UPDATE_INTERACTIONS = 'UPDATE_INTERACTIONS';

export const GET_TWITTER_TRENDS_REQUEST = 'GET_TWITTER_TRENDS_REQUEST';
export const GET_TWITTER_TRENDS_SUCCESS = 'GET_TWITTER_TRENDS_SUCCESS';
export const GET_TWITTER_TRENDS_FAILURE = 'GET_TWITTER_TRENDS_FAILURE';

export const EXPORT_TO_FILE_REQUEST = 'EXPORT_TO_FILE_REQUEST';
export const EXPORT_TO_FILE_SUCCESS = 'EXPORT_TO_FILE_SUCCESS';
export const EXPORT_TO_FILE_FAILURE = 'EXPORT_TO_FILE_FAILURE';

export const UPDATE_PANEL_ORDER_REQUEST = 'UPDATE_PANEL_ORDER_REQUEST';
export const UPDATE_PANEL_ORDER_SUCCESS = 'UPDATE_PANEL_ORDER_SUCCESS';
export const UPDATE_PANEL_ORDER__FAILURE = 'UPDATE_PANEL_ORDER__FAILURE';

export const GET_INSTANT_POLL_STATS_REQUEST = 'GET_INSTANT_POLL_STATS_REQUEST';
export const GET_INSTANT_POLL_STATS_SUCCESS = 'GET_INSTANT_POLL_STATS_SUCCESS';
export const GET_INSTANT_POLL_STATS_FAILURE = 'GET_INSTANT_POLL_STATS_FAILURE';



// WEBPACK FOOTER //
// ./src/store/modules/interaction/mutation-types.js